import script from "./BaseForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseForm.vue?vue&type=script&lang=ts&setup=true"

export default script